<template>
  <Modal id="exclusive-control" title="" @ok="ok">
    <template id="default">
      一時的にデータを更新できませんでした。もう一度操作をやり直してください。
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal'

export default {
  components: {
    Modal
  },
  computed: {
    show() {
      return this.$store.state.app.exclusiveControl
    }
  },
  methods: {
    ok() {
      this.$store.commit('app/SET_EXCLUSIVE_CONTROL', false)
      window.location.reload()
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.$modal.show('exclusive-control')
      } else {
        this.$modal.close('exclusive-control')
      }
    }
  }
}
</script>
